module.exports = __webpack_public_path__ + "static/media/SF-Compact-Text-Italic.63764180.otf";